export const RefreshIcon = ({
  spinning = false,
  className = 'block shrink-0',
}: {
  spinning?: boolean;
  className?: string;
}) => (
  <svg
    className={`${className}${spinning ? ' animate-spin' : ''}`}
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M21 12a9 9 0 1 1-2.64-6.36" />
    <path d="M21 3v6h-6" />
  </svg>
);
